import React from "react";
import CommonPageHeader from "../../../components/CommonPageHeader/CommonPageHeader";
import Footer from "../../../components/Shared/Footer";
import HomeHeader from "../../Home/Home/HomeHeader/HomeHeader";
import ShopBanner from "./ShopBanner/ShopBanner";
import { useParams } from "react-router-dom";
const ShopPageTwo = () => {
  let { page } = useParams();
  console.log(page);

  return (
    <>
      <HomeHeader />

      <CommonPageHeader title="Cell Marque" subtitle="Shop" />
      <ShopBanner page={page} />
      <Footer />
    </>
  );
};

export default ShopPageTwo;
